<template>
    <v-form
        ref="form"
        >
        <v-row>
            <v-col cols="12">
                <v-text-field
                    v-model="form.code"
                    outlined
                    dense
                    hide-details="auto"
                    label="Code"
                    clearable
                    >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.from"
                    outlined
                    dense
                    hide
                    label="From"
                    clearable
                    >
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.to"
                    outlined
                    dense
                    hide
                    label="To"
                    clearable
                    >
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="form.created_by_id"
                    outlined
                    dense
                    hide-details="auto"
                    label="Created By"
                    clearable
                    @update:search-input="searchUsers"
                    item-text="name"
                    item-value="id"
                    :items="users"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-text-field
                    v-model="form.purchase_order_code"
                    outlined
                    dense
                    hide-details="auto"
                    label="Purchase Order"
                    clearable
                    >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="form.supplier_id"
                    outlined
                    :items="suppliers"
                    item-value="id"
                    item-text="name"
                    @update:search-input="searchSuppliers"
                    dense
                    hide-details="auto"
                    label="Supplier"
                    clearable>
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select
                    dense
                    outlined
                    label="State"
                    hide-details="auto"
                    :items="states"
                    v-model="form.state"
                >

                </v-select>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import PDatePicker from "./../../components/common/PDatePicker"
import { mapActions, mapGetters } from 'vuex';
import invoice from "./../../services/purchase/invoice"
import UserAPI from './../../services/purchase/user'
export default {
    name: "PurchaseInvoiceListSearch",
    components: {
        PDatePicker
    },
    data() {
        return {
            form: {
                from: null,
                to: null,
                state: null,
                supplier_id: null,
                purchase_order_code: null,
                created_by_id: null
            },
            status : [],
            users: [],
            usersLoading: false
        }
    },
    computed: {
        ...mapGetters({
            params: "purchase/invoice/params",
            loading: "purchase/supplier/loading",
            suppliers: "purchase/supplier/list",
        })
    },
    methods: {
        ...mapActions({
            updateParams: "purchase/invoice/updateParams",
            searchSuppliers: "purchase/supplier/search"
        }),
        submit() {
            this.updateParams(this.form);
        },
        searchUsers(query) {
            this.usersLoading = true;
            UserAPI.search(query)
                        .then(res => {
                            this.users = Array.from(new Set([...this.users, ... res.data]));
                        }).finally(() => {
                            this.usersLoading = false;
                        })
        }
    },
    created() {
        this.form = {...this.params}
        invoice.states().then(response =>  this.states = response.data)
    }

}
</script>

<style>

</style>